import React, { FC, memo } from 'react';
import { Input, Select, Space } from 'udesk-ui';
import RandomFieldSelectList from './components/RandomFieldSelectList';
import { AssociateDataField } from 'src/api/types';
import UdeskLocales from 'UdeskLocales';

export interface TemplateProps {
    value?:
        | {
              type?: 1;
              associateDataFieldList?: AssociateDataField[];
          }
        | {
              type?: 2;
              associateDataFieldList?: AssociateDataField[];
          }
        | {
              type?: 3;
              fixValue?: string;
          };
    onChange?: (value: TemplateProps['value']) => void;
    dataSourceList?: number[];
}

const Template: FC<TemplateProps> = memo((props) => {
    const { value, onChange, dataSourceList } = props;

    const onKeyTypeChange = (v: 1 | 2 | 3) => {
        const newValue = {
            ...value,
            type: v,
            associateDataFieldList: undefined,
            fixValue: undefined,
        };
        onChange?.(newValue);
    };

    const onValueChange = (v: any) => {
        const newValue =
            value?.type === 1 || value?.type === 2
                ? {
                      ...value,
                      associateDataFieldList: v,
                  }
                : value?.type === 3
                ? {
                      ...value,
                      fixValue: v,
                  }
                : undefined;
        onChange?.(newValue);
    };

    return (
        <Space>
            <Select
                value={value?.type}
                onChange={(v) => onKeyTypeChange(v)}
                options={[
                    {
                        value: 1,
                        label: /* 随路字段 */ UdeskLocales['current'].pages.semanticIntelligence
                            .externalInterface.detail.components.paramsList.components.valueSpecial1
                            .index.followthepathField,
                    },
                    {
                        value: 2,
                        label: /* 预处理字段 */UdeskLocales['current'].pages.semanticIntelligence.aiAgent.detail.components.paramsList.components.value.index.preprocessedField,
                    },
                    {
                        value: 3,
                        label: /* 固定值 */UdeskLocales['current'].pages.semanticIntelligence.aiAgent.detail.components.paramsList.components.value.index.fixedValue,
                    },
                ]}
                style={{ width: 100 }}
            />

            {value?.type === 1 ? (
                <RandomFieldSelectList
                    value={value?.associateDataFieldList}
                    onChange={(v) => onValueChange(v)}
                    dataSourceList={dataSourceList}
                    typeList={[1]}
                />
            ) : value?.type === 2 ? (
                <RandomFieldSelectList
                    value={value?.associateDataFieldList}
                    onChange={(v) => onValueChange(v)}
                    dataSourceList={dataSourceList}
                    typeList={[3]}
                />
            ) : value?.type === 3 ? (
                <Input
                    value={value?.fixValue}
                    onChange={(e) => onValueChange(e.target.value)}
                    style={{ width: 200 }}
                    placeholder={/* 请输入字段 */UdeskLocales['current'].pages.semanticIntelligence.aiAgent.detail.components.paramsList.components.value.index.pleaseEnterTheField}
                />
            ) : null}
        </Space>
    );
});

export default Template;
